import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEditSide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      stroke="#454655"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.5 7.438c0-1.224 0-1.835.2-2.318A2.63 2.63 0 0 1 5.12 3.7c.483-.2 1.094-.2 2.318-.2h13.125c1.223 0 1.834 0 2.317.2a2.63 2.63 0 0 1 1.42 1.42c.2.483.2 1.094.2 2.318M8.75 24.5h10.5m-7.547-21v21m4.594-21v21"
    />
  </svg>
);
export default SvgEditSide;
